import * as React from "react";
import {DOCTRINES, SKILL_TABS, SKILLS} from "./model/fixtures";
import {GlobalInfo, UserInfo} from "./context";
import {getUser} from "./model/data";
import {database} from "./config";
import {Link, Route, Switch, useParams} from "react-router-dom";
import {toast} from "react-toastify";
import {numberWithCommas, renderShortDate, toTitleCase} from "./util";
import {If, Toggle} from "./Common";
import {Card} from "react-bootstrap";

let getSp = (skillIdk, skillName, skillLevel) => {
  console.log(skillName);
  let levelFiveSP = SKILLS[skillName].cost[skillIdk];
  switch(skillLevel) {
    case 0: return 0;
    case 1: return levelFiveSP * 0.0009765625;
    case 2: return levelFiveSP * 0.004552083333;
    case 3: return levelFiveSP * 0.02572135417;
    case 4: return levelFiveSP * 0.1455286458;
    case 5: return levelFiveSP * 0.8232213542;
    default: return NaN;
  }
};

class PersonalSkillsPage extends React.Component {

  constructor(props, context) {
    super(props);
    this.state = {
      skills: context.userData.skills || {},
      tab: 'Doctrine',
    };
  }

  get(skillName, idx) {
    let d = this.state.skills[skillName] || (
        this.context.userData.skills && this.context.userData.skills[skillName]);
    if(!d) {
      return 0
    }
    return d[idx] || 0
  }

  set(skillName, idx, newVal) {
    if (newVal) {
      newVal = parseInt(newVal);
      if (isNaN(newVal)) {
        return
      }
    } else {
      newVal = 0;
    }
    if (newVal < 0) {
      newVal = 0
    }
    if (newVal > 5) {
      newVal = 5
    }
    let d = this.state.skills[skillName];
    if (!d) {
      d = [0, 0, 0];
    }
    d[idx] = newVal;
    let newSkills = this.state.skills;
    newSkills[skillName] = d;
    this.setState({skills: newSkills});

    // Auto-save
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.timeout = setTimeout(() => {
      this.save();
      this.timeout = null;
    }, 5000)
  }

  save() {
    database.runTransaction(transaction => {
      let userRef = database.collection("users").doc(this.context.userInfo.id);
      return transaction.get(userRef).then((user) => {
        return transaction.update(userRef, {
          skills: this.state.skills,
          skillsSet: true,
          skillsUpdated: +(new Date()),
        })
      })
    }).then(() => {
      toast.success("Skills saved")
    })
  }

  renderSkillTable() {
    return <table className={"table table-striped skill-table"}>
      <thead>
      <tr>
        <th>Skill</th>
        <th>Basic</th>
        <th>Advanced</th>
        <th>Expert</th>
        <th>Total SP</th>
      </tr>
      </thead>
      <tbody>
      {Object.keys(SKILLS).map(skillName => {
            if (SKILLS[skillName].tab !== this.state.tab) {
              return null;
            }
            let [basicLevel, advancedLevel, expertLevel] = [this.get(skillName, 0), this.get(skillName, 1), this.get(skillName, 2)];
            let sp = 0;
            for(let i=1; i<=basicLevel; i++) {
              sp += getSp(0, skillName, i);
            }
                        for(let i=1; i<=advancedLevel; i++) {
              sp += getSp(1, skillName, i);
            }            for(let i=1; i<=expertLevel; i++) {
              sp += getSp(2, skillName, i);
            }
            return <tr key={skillName}>
              <th><Link to={"/skills/" + skillName}>{skillName}</Link></th>
              <td><input className="form-control" type="number" placeholder="0" value={basicLevel}
                         onChange={evt => this.set(skillName, 0, evt.target.value)}/></td>
              <td><input className="form-control" type="number" placeholder="0" value={advancedLevel}
                         onChange={evt => this.set(skillName, 1, evt.target.value)}/></td>
              <td><input className="form-control" type="number" placeholder="0" value={expertLevel}
                         onChange={evt => this.set(skillName, 2, evt.target.value)}/></td>
              <td>{numberWithCommas(sp)} SP</td>
            </tr>
          }
      )}
      </tbody>
    </table>
  }

  renderDoctrine() {
    return <table className={"table"}>
      <thead>
      {/*<tr>*/}
      {/*  <th>Doctrine</th>*/}
      {/*  <th>Progress</th>*/}
      {/*  <th>Skills missing</th>*/}
      {/*</tr>*/}
      <tr>
          <td colSpan={3} className={"text-muted"}>
            Pilots are expected to train at least one ship in each of our primary doctrines (Dragon Fleet, Banzai Fleet, and Frigate Fleet). Utility doctrines are optional.
            Refer to <a href={"https://discord.com/channels/744258814290690128/755662441060499536/757443413896462377"} target={"_blank"} rel={"noopener noreferrer"}>alliance discord</a> for fitting guides.
          </td>
      </tr>
      </thead>
      <tbody>
      {Object.keys(DOCTRINES).map((doctrineName) => {
        let doctrine = DOCTRINES[doctrineName];
        let missingSkills = [];
        let spPresent = 0;
        let spMissing = 0;

        let parseSkill = (skillName) => {
          let skillIdx = 0;
          if (skillName.indexOf('Advanced') === 0) {
            skillIdx = 1;
            skillName = skillName.slice(8)
          }
          if (skillName.indexOf('Expert') === 0) {
            skillIdx = 2;
            skillName = skillName.slice(6)
          }
          let skillLevel = parseInt(skillName.slice(-1));
          skillName = skillName.slice(0, -1).trim();
          return [skillIdx, skillName, skillLevel];
        };

        doctrine.forEach((fmtSkillName) => {
          let [skillIdx, skillName, skillLevel] = parseSkill(fmtSkillName);
          let hasSkill = false;
          let sp = getSp(skillIdx, skillName, skillLevel);
          if (this.get(skillName, skillIdx) >= skillLevel) {
            spPresent += sp;
          } else {
            missingSkills.push([fmtSkillName, sp]);
            spMissing += sp;
          }
        });

        return <tr key={doctrineName} className={spMissing === 0 ? "table-success" : ""}>
          <td>{doctrineName}</td>
          <td>
            {numberWithCommas(spPresent)} / {numberWithCommas(spPresent + spMissing)} SP
          </td>
          <td>
            <If cond={spMissing}>
              {missingSkills.length} missing
              <Toggle>
                <ul>
                  {missingSkills.map((skillNameAndSP) =>
                      <li key={skillNameAndSP[0]}>{skillNameAndSP[0]} ({numberWithCommas(skillNameAndSP[1])} SP)</li>
                  )}
                </ul>
              </Toggle>
            </If>
            <If cond={!spMissing}>
              All done!
            </If>
          </td>
        </tr>

      })}
      </tbody>
    </table>
  }

  render() {

    return <div className={"container"}>

      <ul>
        <li>Enter your personal skills on this page. If you have alts, make it the maximum of any of your characters.</li>
        <li>Click a skill name to see other pilots with that skill.</li>
        <li>Changes will automatically save.</li>
      </ul>

      {/*<button className={"btn btn-primary mb-2"} onClick={() => this.save()}>Save</button>*/}
      <Card>
        <Card.Header>
          <ul className="nav nav-pills card-header-pills">
            {['Doctrine'].concat(SKILL_TABS).map(tabName => {
              return <li className="nav-item">
                <a className={"nav-link" + (this.state.tab === tabName ? " active" : "")} href="#" onClick={evt => {
                  this.setState({
                    tab: tabName
                  });
                  evt.preventDefault()
                }}>{toTitleCase(tabName)}</a>
              </li>
            })}
          </ul>
        </Card.Header>

        {this.state.tab === 'Doctrine' ? this.renderDoctrine() : this.renderSkillTable()}
      </Card>

    </div>
  }

}

PersonalSkillsPage.contextType = GlobalInfo;


class SkillListPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      users: [],
    }
  }

  componentDidMount() {
    // new firebase.firestore.FieldPath("skills", this.props.skillName, "0"), ">", 0
    database.collection("users").where("skillsSet", "==", true).onSnapshot((querySnapshot) => {
      let users = [];
      querySnapshot.forEach((doc) => {
        let user = doc.data();
        if (user.skills && user.skills[this.props.skillName]) {
          users.push(user);
        }
      });
      users.sort((a, b) => {
        a = a.skills[this.props.skillName];
        b = b.skills[this.props.skillName];
        return (b[0] + b[1] + b[2]) - (a[0] + a[1] + a[2])
      });
      this.setState({
        users: users,
      })
    });
  }

  renderSkill(user) {
    if (!user.skills || !user.skills[this.props.skillName]) {
      return "unknown"
    }
    return user.skills[this.props.skillName].join("/")
  }

  render() {
    console.log(this.state.users);
    return <div className={"container"}>
      <h5>{this.props.skillName}</h5>
      <table className={"table"}>
        <thead>
        <tr>
          <th>Pilot</th>
          <th>Skill</th>
          <th>Updated</th>
          <th>Last (app) login</th>
        </tr>
        </thead>
        <tbody>
        {this.state.users.map(user =>
            <tr className={(user.roles && (user.roles.engineer || user.roles.finance || user.admin)) ? "table-success" : ""}>
              <td>{user.name}</td>
              <td>{this.renderSkill(user)}</td>
              <td>{renderShortDate(user.skillsUpdated)}</td>
              <td>{renderShortDate(user.lastLogin)}</td>
            </tr>
        )}
        </tbody>
      </table>
    </div>
  }
}

function SkillListPageWrapper() {
  let {skillName} = useParams();
  return <SkillListPage skillName={skillName}/>
}

export default class SkillsPage extends React.Component {
  render() {
    return <Switch>

      <Route path={"/skills/:skillName"}>
        <SkillListPageWrapper/>
      </Route>
      <Route path={"/skills"}>
        <PersonalSkillsPage/>
      </Route>
    </Switch>
  }
}